/* assets/cart-bundle-sync.js

   2026-08-05 Bundle quantity sync for the cart page and cart drawer.

   Loaded globally from layout/theme.liquid (unlike customaddons-dev.js, which only
   loads on product templates - which is why this lives in its own file).

   Shopify's nested cart lines cascade REMOVAL from parent to children but not
   quantity changes, so doubling a pole would leave its brackets at the old count.
   The parent row carries data-child-lines='[{"key":..,"perBundle":..}]' (rendered
   by snippets/cart-line-items.liquid). 2026-09-18: perBundle comes from the child
   line's _Per bundle property, stamped by the product page, and only falls back
   to the live child/parent ratio for carts built before that property existed.
   The ratio alone was the cause of order #3798 shipping with one bracket: a
   second add of the same pole merged into the existing line (pole 2, brackets 2,
   ratio 1) and the customer's change back to 1 pole scaled the brackets to 1. This capture-phase listener runs before the
   theme's own change handler on the quantity input: it scales every child line to
   newQty x perBundle via /cart/update.js, then re-dispatches the change so
   theme.dev.js CartItems handles the parent update and the full re-render through
   its normal path (loadbar, error handling, listener re-binding included).

   Setting the input to 0 passes straight through - that is a removal, and removal
   cascades to children natively. Verified against the live cart API on 2026-08-05:
   update.js accepts child line keys and change.js on the parent leaves child
   quantities untouched, in both orders. */
(function () {
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-quantity-input]')) { return; }
    if (input.dataset.pdBundleForward) { delete input.dataset.pdBundleForward; return; }
    var row = input.closest('[data-cart-item].has_nested_lines');
    if (!row || !row.dataset.childLines) { return; }
    var newQty = parseInt(input.value, 10);
    if (isNaN(newQty) || newQty < 1) { return; }
    var children;
    try { children = JSON.parse(row.dataset.childLines); } catch (err) { return; }
    if (!children || !children.length) { return; }

    e.stopImmediatePropagation();

    var updates = {};
    children.forEach(function (child) {
      updates[child.key] = newQty * (child.perBundle || 1);
    });

    var cartRoute = (window.theme && theme.routes && theme.routes.cart) ? theme.routes.cart : '/cart';
    fetch(cartRoute + '/update.js', {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .catch(function () { /* forward the parent change regardless so the cart never locks up */ })
      .finally(function () {
        input.dataset.pdBundleForward = '1';
        input.dispatchEvent(new Event('change'));
      });
  }, true);
})();
